import React, { useEffect, useState } from 'react'
import { useShow, IResourceComponentsProps, useGetIdentity, useOne, useNavigation, useList, useUpdate } from '@pankod/refine-core'
import { ErrorComponent } from '@pankod/refine-antd'
import { Radio } from 'antd'
import type { RadioChangeEvent } from 'antd'
import type { ColumnsType } from 'antd/lib/table'
import { IGrade, IQuestion, IStrand, IWorkRequest } from 'interfaces'
// import { EditQuestion } from './edit'
import ReactMarkdown from 'react-markdown'
import { getTeacherLevelByStrand } from 'gql/query'
import '../questions/style.css'
import { CheckUserAccess } from 'components/accessability'
import {
  Space,
  Table,
  Tag,
  Progress,
  Breadcrumb,
  Tooltip,
  Icons,
  Button,
  PageHeader,
  Typography,
  Skeleton,
  Descriptions,
  Divider,
  EditButton,
  Image,
  useModalForm,
  Col,
  Row,
} from '@pankod/refine-antd'
import { createLogActivateDeactivate, createLogPublished, updateQuestionStatus, createLogRePublished } from 'gql/mutations'
import metaData from 'metadata/questions'
// import wr_metadata from 'metadata/workrequests'
// import { CompletionStatus, getWorkRequestStatusCount } from 'helpers'
import { nhost } from 'utility'
import {
  createMailForApproval,
  createMailForReview,
  createMailForReviewRequireAmending,
  createMailOpenRequireAmending,
  createMailRejectedAtApproval,
  createMailRejectedAtRewiew,
} from 'helpers'
import QuestionLogs from 'components/questionlogs'
import QuestionUsageAnalysis from 'components/questionUsageAnalysis'
import { useUserContext } from 'context/user'
import RichTextRender from 'components/questions/rich_text_render'
const { Text } = Typography
interface romanType {
  [key: number]: string
}
interface alphabetsType {
  [key: number]: string
}
type ReviewerApprover = {
  reviewer_id: string
  reviewer_name: string
  approvers: object[]
}
const roman: romanType = { 1: 'i', 2: 'ii', 3: 'iii', 4: 'iv', 5: 'v', 6: 'vi', 7: 'vii', 8: 'viii' }
const alphabets: alphabetsType = { 1: 'a', 2: 'b', 3: 'c', 4: 'd', 5: 'e', 6: 'f', 7: 'g', 8: 'h' }
interface MCQDataType {
  type?: string
  option_text: string
  option_image_id: string
  option_image_name: string
  option_insight: string
  option_flag: string
}

interface MatchDataType {
  left_label_text: string
  right_label_text: string
  option_insight: string
  option_comments: string
  left_label_image: string
  right_label_image: string
}

interface FillDataType {
  option_image_id: any
  right_answer: string
  option_comments: string
}

interface ShortAnswerDataType {
  component_name: string
  rating_1: string
  rating_2: string
  rating_3: string
  rating_4: string
  weightage: string
}

const MCQColumns: ColumnsType<MCQDataType> = [
  {
    title: 'Option ',
    dataIndex: 'option_text',
    render: (_, record) => {
      if (record.option_image_id && record?.type === 'Image') {
        const publicUrl = nhost.storage.getPublicUrl({ fileId: record?.option_image_id })
        return <>{publicUrl && <Image width={100} src={publicUrl} />}</>
      } else {
        return (
          <>
            <RichTextRender content={record?.option_text} styles={{ width: undefined, height: undefined }} />
          </>
        )
      }
    },
  },
  {
    title: 'Option Flag',
    dataIndex: 'option_flag',
    render: (_, { option_flag }) => {
      let color = 'geekblue'
      if (option_flag === 'Right Answer' || option_flag === 'RA') {
        color = 'green'
      }
      if (option_flag === 'Most Wrong' || option_flag === 'WW') {
        color = 'volcano'
      }
      return <Tag color={color}>{option_flag?.toUpperCase()}</Tag>
    },
  },
  {
    title: 'Option Insight',
    dataIndex: 'option_insight',
  },
  {
    title: 'Reviewer Comments',
    dataIndex: 'reviewer_comments',
  },
  {
    title: 'Approver Comments',
    dataIndex: 'approver_comments',
  },
]

const MatchColumns: ColumnsType<MatchDataType> = [
  {
    title: 'Left Label',
    dataIndex: 'left_label_text',
    render: (_, record) => {
      if (record?.left_label_image) {
        const publicUrl = nhost.storage.getPublicUrl({ fileId: record?.left_label_image })
        return <>{publicUrl && <Image width={100} height={100} src={publicUrl} style={{ marginLeft: 0, objectFit: 'contain' }} />}</>
      } else {
        return (
          <>
            <RichTextRender content={record?.left_label_text} styles={{ width: undefined, height: undefined }} />
          </>
        )
      }
    },
  },
  {
    title: 'Right Label',
    dataIndex: 'right_label_text',
    render: (_, record) => {
      if (record?.right_label_image) {
        const publicUrl = nhost.storage.getPublicUrl({ fileId: record?.right_label_image })
        return <>{publicUrl && <Image width={100} height={100} src={publicUrl} style={{ marginLeft: 0, objectFit: 'contain' }} />}</>
      } else {
        return (
          <>
            <RichTextRender content={record?.right_label_text} styles={{ width: undefined, height: undefined }} />
          </>
        )
      }
    },
  },
  {
    title: 'Lebel Insight',
    dataIndex: 'option_insight',
  },
  {
    title: 'Reviewer Comments',
    dataIndex: 'reviewer_comments',
  },
  {
    title: 'Approver Comments',
    dataIndex: 'approver_comments',
  },
]

const FillColumns: ColumnsType<FillDataType> = [
  {
    title: 'Right Answer',
    dataIndex: 'right_answer',

    render: (_, record) => {
      if (record.option_image_id) {
        const publicUrl = nhost.storage.getPublicUrl({ fileId: record?.option_image_id })
        return <>{publicUrl && <Image width={100} src={publicUrl} />}</>
      } else {
        return (
          <>
            <RichTextRender content={record?.right_answer} styles={{ height: undefined, width: undefined }} />
          </>
        )
      }
    },
  },
  {
    title: 'Reviewer Comments',
    dataIndex: 'reviewer_comments',
  },
  {
    title: 'Approver Comments',
    dataIndex: 'approver_comments',
  },
]

const ShortAnswerColumns: ColumnsType<ShortAnswerDataType> = [
  {
    title: 'Component Name',
    dataIndex: 'component_name',
  },
  {
    title: 'Rating 1',
    dataIndex: 'rating_1',
  },
  {
    title: 'Rating 2',
    dataIndex: 'rating_2',
  },
  {
    title: 'Rating 3',
    dataIndex: 'rating_3',
  },
  {
    title: 'Rating 4',
    dataIndex: 'rating_4',
  },
  {
    title: 'Weightage',
    dataIndex: 'weightage',
  },
]

export const CleanupQuestionShow: React.FC<IResourceComponentsProps> = () => {
  const { data: user } = useGetIdentity()
  const role = user?.defaultRole
  const { show } = useNavigation()
  const { userRole } = useUserContext()
  const { mutateAsync: updateQuestionAsync } = useUpdate<IQuestion>()
  const [questionStatus, setQuestionStatus] = useState<string>('')
  const [reviewers, setReviewers] = useState<string[]>([])
  const [approvers, setApprovers] = useState<string[]>([])
  const [teacherLevel, setTeacherLevel] = useState('')
  const [errorCode, setErrorCode] = useState<number>(200)

  // console.log(window.location.href)
  // const lastIndex = window.location.href.lastIndexOf('/')
  // console.log(lastIndex)

  const { queryResult, setShowId } = useShow<IQuestion>({
    metaData,
    resource: 'questions',
    id: window.location.href.substring(window.location.href.lastIndexOf('/') + 1),
  })
  const { mutateAsync: updateQuestionParameters } = useUpdate<IQuestion>()

  const { data, isLoading } = queryResult
  const record = data?.data

  useEffect(() => {
    let code: any = 200
    code = CheckUserAccess('cleanup', 'show', user?.id, record, userRole)
    setErrorCode(code)
  }, [user, record, userRole])

  const [value, setValue] = useState(1)

  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
    close,
  } = useModalForm({
    resource: 'questions',
    action: 'edit',
    metaData,
    redirect: false,
  })

  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value)
  }

  const handleQUestionStatusChange = (status: string) => {
    if (record?.id) {
      let reviewerId: any = null
      let approverId: any = null
      if (userRole === 'qbincharge') {
        if (status === 'Published') {
          updateQuestionStatus(record?.id, status).then(() => createLogPublished(user?.id, record?.work_request, record?.id, record?.paper?.id))
        }
      }
    }
  }
  useEffect(() => {
    if (record?.strand_id !== null && record?.strand_id !== undefined && record?.strand_id !== '') {
      getTeacherLevelByStrand(record?.strand_id).then((resp: any) => {
        setTeacherLevel(resp?.strands?.[0]?.teacher_level?.name)
      })
    }
  }, [record])
  useEffect(() => {
    if (record?.status) setQuestionStatus(record?.status)
  }, [record])
  // const gradeList = useList<IGrade>({
  //   resource: 'grades',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   config: {
  //     pagination: { pageSize: 1000 },
  //   },
  // })

  // const handleCreateClone = () => {
  //   if (record?.id) {
  //     if (userRole === 'qbincharge') {
  //       if (record?.status === 'Require QBIncharge Edit') {
  //         updateQuestionStatus(record?.id, 'Edited By QBIncharge').then(() =>
  //           createLogPublished(user?.id, record?.work_request, record?.id, record?.paper?.id)
  //         )
  //       }
  //     }
  //   }
  // }

  const handleRePublish = async (record: IQuestion) => {
    if (record?.id) {
      await updateQuestionAsync({ id: record?.id, resource: 'questions', values: { status: 'Published', qb_permit: true } })
      await createLogRePublished(user?.id, record?.work_request, record?.id, record?.paper)
      // await createLogPublished(user?.id, record?.work_request, record?.id, record?.paper)
      // await createLogActivateDeactivate(user?.id, record?.work_request, record?.id, record?.paper, 'active')
      // updateQuestionStatus(record?.id, 'Published').then(() => {
      //   createLogPublished(user?.id, record?.work_request, record?.id, record?.paper)
      // })
    }
    queryResult?.refetch()
  }

  const handleQbEdit = async (record: IQuestion, action: string) => {
    if (record?.id) {
      await updateQuestionAsync({ id: record?.id, resource: 'questions', values: { qb_permit: action === 'inactive' ? false : true } })
      await createLogActivateDeactivate(user?.id, record?.work_request, record?.id, record?.paper, action)
    }
    queryResult?.refetch()
  }

  const renderApproverReviewerUsers = () => {
    let arr_reviewer: object[] = []
    let arr_approver: ReviewerApprover[] = []
    JSON.stringify(record?.work_request?.workRequestReviewers) !== '{}' &&
      record?.work_request?.workRequestReviewers?.map((item: any) => {
        if (record?.work_request?.workRequestApprovers?.length > 0) {
          record?.work_request?.workRequestApprovers?.map((approv: any) => {
            if (approv?.reviewer_id === item?.user_id) {
              var found = arr_approver.findIndex(function (doundIndex: any) {
                return doundIndex?.reviewer_id === approv.reviewer_id
              })
              if (found > -1) {
                arr_approver[found]?.approvers?.push(approv?.userByApprover?.displayName)
              } else {
                let app_arr: object[] = []
                app_arr.push(approv?.userByApprover?.displayName)
                arr_approver.push({
                  reviewer_id: approv?.reviewer_id,
                  reviewer_name: approv?.userByReviewerId[0]?.displayName,
                  approvers: app_arr,
                })
              }
            } else {
              arr_approver.push({
                reviewer_id: item?.user_id,
                reviewer_name: item?.userByReviewerId?.displayName,
                approvers: [],
              })
            }
          })
        } else {
          arr_approver.push({
            reviewer_id: item?.user_id,
            reviewer_name: item?.userByReviewerId?.displayName,
            approvers: [],
          })
        }
      })
    arr_approver = arr_approver.filter(
      (elem: any, index: any, self: any) =>
        self.findIndex((t: any) => {
          return t.reviewer_id === elem.reviewer_id
        }) === index
    )

    return (
      <>
        {record?.request_type !== 'Uploaded' ? (
          arr_approver?.length > 0 ? (
            <>
              <Col xs={24} lg={16}>
                <div>
                  <b>{`Reviewers    &    Approvers`}</b>
                  {arr_approver?.map((item: any) => (
                    <div style={{ display: 'flex', padding: '2px 0' }}>
                      <div style={{ display: 'block', padding: '2px 0' }}> {`${item?.reviewer_name}   :   `}</div>
                      {item?.approvers?.length > 0 &&
                        item?.approvers?.map((approv: any) => (
                          <div style={{ display: 'block', padding: '2px 0' }}>
                            <Text keyboard>{approv}</Text>
                          </div>
                        ))}
                    </div>
                  ))}
                </div>
              </Col>
            </>
          ) : arr_reviewer?.length > 0 ? (
            <>
              <Col xs={24} lg={16}>
                <div>
                  <b>{`Reviewers`}</b>
                  {arr_reviewer?.map((item: any) => (
                    <div style={{ display: 'block', padding: '2px 0' }}> {item}</div>
                  ))}
                </div>
              </Col>
            </>
          ) : (
            <>
              <Col xs={24} lg={8}>
                <div>
                  <b>{`Reviewers    &    Approvers`}</b>
                </div>
              </Col>
            </>
          )
        ) : null}
      </>
    )
  }
  console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx', record)
  return (
    <>
      {errorCode === 200 ? (
        <PageHeader
          className="site-page-header-responsive"
          ghost={false}
          title={`#${record?.question_id ?? ''} - ${record?.grade?.name ?? ''} ${record?.topic?.sub_theme?.theme?.subject?.name ?? ''} ${
            record?.question_type?.name
          }`}
          extra={[
            (userRole === 'admin' || userRole === 'qbincharge' || userRole === 'subjectincharge') && <QuestionLogs questionId={record?.id} />,
            (userRole === 'admin' || userRole === 'qbincharge' || userRole === 'subjectincharge') && (
              <QuestionUsageAnalysis questionId={record?.id} questionTitle={record?.title} />
            ),
            <Button key="close" onClick={() => window.history.back()} icon={<Icons.LeftOutlined />}>
              Back
            </Button>,
            // userRole === 'qbincharge' ||
            //   (userRole === 'admin' && (
            //     <Button
            //       key="re publish"
            //       onClick={() => handleQUestionStatusChange('Published')}
            //       disabled={(questionStatus !== 'Published' && questionStatus !== 'Require QBIncharge Edit') || approvers?.length < 1}
            //     >
            //       Publish
            //     </Button>
            //   )),
            // (userRole === 'qbincharge' || userRole === 'admin') && (
            //   <Button
            //     type="primary"
            //     key="republish"
            //     onClick={() => {
            //       record && handleRePublish(record)
            //     }}
            //     disabled={record?.status === 'Published'}
            //   >
            //     Re-Publish
            //   </Button>
            // ),
            // (userRole === 'qbincharge' || userRole === 'admin') && record?.qb_permit && (
            //   <Button
            //     danger
            //     key="disable"
            //     disabled={!record?.qb_permit}
            //     onClick={() => {
            //       record && handleQbEdit(record, 'inactive')
            //     }}
            //   >
            //     Disable
            //   </Button>
            // ),
            // userRole === 'qbincharge' && (
            //   <Button
            //     key="approved"
            //     onClick={() => {
            //       handleQUestionStatusChange('Published')
            //       record && createLogPublished(record?.approver_id, workRequestRecord?.data, record?.id)
            //     }}
            //     disabled={questionStatus !== 'For Approval'}
            //   >
            //     Approve
            //   </Button>
            // ),
            // userRole === 'admin' || userRole === 'qbincharge' ? (
            //   <EditButton
            //     key="edit"
            //     disabled={record?.status !== 'Edited By QBIncharge'}
            //     icon={<Icons.EditOutlined />}
            //     type="primary"
            //     recordItemId={record?.clone?.id}
            //     onClick={() => {
            //       editShow(record?.clone?.id)
            //     }}
            //   >
            //     Edit Clone
            //   </EditButton>
            // ) : null,
          ]}
        >
          <Descriptions size="small" column={2}>
            <Descriptions.Item label="">
              <Tag
                color={
                  questionStatus === 'Published'
                    ? 'green'
                    : questionStatus === 'Rejected at Review' || questionStatus === 'Rejected at Approval' || questionStatus === 'Retired'
                    ? 'volcano'
                    : questionStatus === 'Open (Require Amending)' || questionStatus === 'For Review (Require Amending)'
                    ? 'pink'
                    : 'geekblue'
                }
              >
                {questionStatus}
              </Tag>
            </Descriptions.Item>
          </Descriptions>
          <Descriptions size="small" column={2}>
            {record?.work_request_id && (
              <Col span={24}>
                <Descriptions.Item label="Work Request" style={{ display: 'block' }}>
                  <Space>
                    <Typography.Text strong>Work Request:</Typography.Text>
                    <Typography.Text
                      disabled
                      strong
                      // onClick={() => {
                      //   if (record?.work_request_id) show('work_requests', record?.work_request_id)
                      // }}
                    >{`#${record?.work_request?.request_id ?? ''} ${record?.work_request?.name ?? ''}`}</Typography.Text>
                  </Space>
                </Descriptions.Item>
              </Col>
            )}
            {record?.paper_id && (
              <Col span={24}>
                <Descriptions.Item label="Paper" style={{ display: 'block' }}>
                  <Space>
                    <Typography.Text strong>Paper Id: </Typography.Text>
                    <Typography.Text
                      disabled
                      strong
                      // onClick={() => {
                      //   if (record?.paper_id) show('papers', record?.paper_id)
                      // }}
                    >{`#${record?.paper?.paper_id ?? ''} ${record?.paper?.paper_smart_id ?? ''}`}</Typography.Text>
                  </Space>
                </Descriptions.Item>
              </Col>
            )}
            {console.log('grades', JSON.stringify(record?.work_request?.workRequestGrades))}
            <Descriptions.Item label="Grade">
              {JSON.stringify(record?.work_request?.workRequestGrades) !== '[]' && record?.work_request?.workRequestGrades !== undefined
                ? record?.work_request?.workRequestGrades?.map((item: any) => <Tag key={item?.grade_id}>{item?.grade?.name}</Tag>)
                : JSON.stringify(record?.question_grades) !== '[]'
                ? record?.question_grades?.map((item: any) => <Tag key={item?.grade_id}>{item?.grade?.name}</Tag>)
                : null}
            </Descriptions.Item>
            {/* <Descriptions.Item label="Grade">{renderGrades(record?.grade_ids)}</Descriptions.Item> */}
            <Descriptions.Item label="Subject">{record?.subject?.name}</Descriptions.Item>
            <Descriptions.Item label="Report Theme(TN_Term_Month)">{record?.report_theme?.name}</Descriptions.Item>
            <Descriptions.Item label="Theme(TN Chapter Name)">{record?.theme?.name}</Descriptions.Item>
            <Descriptions.Item label="Sub-theme (CENTA Concept ID_CENTA Concept Name)">{record?.sub_theme?.name}</Descriptions.Item>
            <Descriptions.Item label="Topic">{record?.topic?.name}</Descriptions.Item>
            <Descriptions.Item label="Question Type">{record?.question_type?.name}</Descriptions.Item>
          </Descriptions>
          <Divider style={{ margin: '0' }} />
          <b>Tags:</b>
          <Descriptions size="small" column={3}>
            <Descriptions.Item label="Competency">{record?.competencies?.name}</Descriptions.Item>
            <Descriptions.Item label="Taxonomy">{record?.tn_taxonomy?.name}</Descriptions.Item>
            <Descriptions.Item label="Teacher Level">
              {record?.strand_id !== null && record?.strand_id !== undefined && record?.strand_id !== '' ? teacherLevel : ''}
            </Descriptions.Item>
            <Descriptions.Item label="Standard">{record?.strand?.name}</Descriptions.Item>
            <Descriptions.Item label="Bloom Level">{record?.bloom_level?.name}</Descriptions.Item>
            <Descriptions.Item label="Difficulty">{record?.difficulty_level?.name}</Descriptions.Item>

            {/* <Descriptions.Item label="Centa Standard">{record?.centa_standard?.name}</Descriptions.Item> */}
            <Descriptions.Item label="Centa Concept">{record?.centa_concept?.name}</Descriptions.Item>
            <Descriptions.Item label="Explanation Type">{record?.explanation_type?.name}</Descriptions.Item>
          </Descriptions>
          <Divider style={{ margin: ' 0' }} />
          {/* <b>Users:</b> */}
          <Row gutter={[16, 0]}>
            <Col xs={24} lg={8}>
              <div>
                <b>Creator</b>

                <div> {record?.request_type !== 'Uploaded' ? record?.userByCreatorId?.displayName : record?.user?.displayName}</div>
              </div>
            </Col>

            {renderApproverReviewerUsers()}
          </Row>
          <Descriptions size="small" column={2}>
            <Descriptions.Item label="Reviewer Stem Comments">{record?.reviewer_stem_comments}</Descriptions.Item>
            <Descriptions.Item label="Approver Stem Comments">{record?.approver_stem_comments}</Descriptions.Item>
          </Descriptions>
          <Divider style={{ margin: ' 0' }} />
          {record?.parent_question && (
            <>
              <b>Parent Question:</b>
              <Descriptions size="small" column={1} layout="vertical">
                <Descriptions.Item>{`${record?.parent_question?.question_id}. ${record?.parent_question?.title}`}</Descriptions.Item>
              </Descriptions>
            </>
          )}
          <b>Question:</b>
          <Descriptions size="small" column={1} layout="vertical">
            <Descriptions.Item>
              {/* <ReactMarkdown>{`${record?.title}`}</ReactMarkdown> */}
              <RichTextRender content={record?.title ?? ''} />
            </Descriptions.Item>
          </Descriptions>

          {record?.option_details && record?.question_type_id === 'MCQ' && (
            <Radio.Group onChange={onChange} value={value}>
              {record?.option_details?.map((option: any, idx: number) => {
                if (option.option_image_id) {
                  const publicUrl = nhost.storage.getPublicUrl({ fileId: option?.option_image_id })
                  return (
                    <Radio key={idx} value={idx + 1}>
                      {publicUrl && <img width={100} src={publicUrl} />}
                    </Radio>
                  )
                } else {
                  return (
                    <Radio key={idx} value={idx + 1}>
                      {/* {option?.option_text} */}
                      <RichTextRender content={option?.option_text} styles={{ width: undefined, height: undefined }} />
                    </Radio>
                  )
                }
              })}
            </Radio.Group>
          )}
          {record?.option_details && record?.question_type_id === 'Match' && (
            <div>
              <Table
                style={{ display: 'inline-block', minWidth: '300px' }}
                showHeader={false}
                size="small"
                bordered
                columns={[
                  {
                    title: 'Left Label',
                    dataIndex: 'left_label_text',
                    render: (text, record, index) => {
                      if (record?.left_label_image) {
                        const publicUrl = nhost.storage.getPublicUrl({ fileId: record?.left_label_image })
                        return (
                          <>
                            {publicUrl && (
                              <>
                                {roman[index + 1]}
                                {')   '}
                                <Image width={100} height={100} style={{ marginLeft: 0 }} src={publicUrl} />
                              </>
                            )}
                          </>
                        )
                      } else {
                        return (
                          <>
                            {
                              <>
                                {roman[index + 1]}
                                {')   '}
                                {/* {record?.left_label_text} */}
                                <RichTextRender content={record?.left_label_text} styles={{ width: undefined, height: undefined }} />
                              </>
                            }
                          </>
                        )
                      }
                    },
                  },
                  {
                    title: 'Right Label',
                    dataIndex: 'right_label_text',
                    render: (text, record, index) => {
                      if (record?.right_label_image) {
                        const publicUrl = nhost.storage.getPublicUrl({ fileId: record?.right_label_image })
                        return (
                          <>
                            {publicUrl && (
                              <>
                                {alphabets[index + 1]}
                                {')   '}
                                <Image width={100} height={100} style={{ marginLeft: 0 }} src={publicUrl} />
                              </>
                            )}
                          </>
                        )
                      } else {
                        return (
                          <>
                            {
                              <>
                                {alphabets[index + 1]} {')   '}
                                {/* {record?.right_label_text} */}
                                <RichTextRender content={record?.right_label_text} styles={{ width: undefined, height: undefined }} />
                              </>
                            }
                          </>
                        )
                      }
                    },
                  },
                ]}
                dataSource={record?.option_details}
                pagination={false}
              />
            </div>
          )}
          <Divider style={{ margin: '12px 0' }} />

          {record?.question_type_id === 'ShortAnswer' && (
            <>
              <b>Expected points in the answer:</b>
              <p>{record?.description}</p>
              <Divider style={{ margin: '12px 0' }} />
            </>
          )}
          {record?.option_details && (
            <>
              {record?.question_type_id === 'MCQ' && (
                <>
                  <b>Option Details:</b>
                  <Table size="small" columns={MCQColumns} dataSource={record?.option_details} pagination={false} />
                </>
              )}
              {record?.question_type_id === 'Match' && (
                <>
                  <b>Label Details:</b>
                  <Table size="small" columns={MatchColumns} dataSource={record?.option_details} pagination={false} />
                </>
              )}
              {record?.question_type_id === 'Fill' && (
                <>
                  <b>Answer Details:</b>
                  <Table size="small" columns={FillColumns} dataSource={record?.option_details} pagination={false} />
                </>
              )}
              {record?.question_type_id === 'ShortAnswer' && (
                <>
                  <b>Rubric Details:</b>
                  <Table size="small" columns={ShortAnswerColumns} dataSource={record?.option_details} pagination={false} />
                </>
              )}
            </>
          )}

          {!record && <Skeleton paragraph={{ rows: 1 }} />}
          {/* <EditQuestion modalProps={editModalProps} formProps={editFormProps} record={record} close={close} /> */}
        </PageHeader>
      ) : (
        <ErrorComponent />
      )}
    </>
  )
}
